/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OverlayModule } from '@angular/cdk/overlay';
import { PortalModule } from '@angular/cdk/portal';
import { LIVE_ANNOUNCER_PROVIDER } from '@angular/cdk/a11y';
import { MatCommonModule } from '@angular/material/core';
import { MatSnackBar } from './snack-bar';
import { MatSnackBarContainer } from './snack-bar-container';
import { SimpleSnackBar } from './simple-snack-bar';
var MatSnackBarModule = (function () {
    function MatSnackBarModule() {
    }
    MatSnackBarModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        OverlayModule,
                        PortalModule,
                        CommonModule,
                        MatCommonModule,
                    ],
                    exports: [MatSnackBarContainer, MatCommonModule],
                    declarations: [MatSnackBarContainer, SimpleSnackBar],
                    entryComponents: [MatSnackBarContainer, SimpleSnackBar],
                    providers: [MatSnackBar, LIVE_ANNOUNCER_PROVIDER]
                },] },
    ];
    /**
     * @nocollapse
     */
    MatSnackBarModule.ctorParameters = function () { return []; };
    return MatSnackBarModule;
}());
export { MatSnackBarModule };
function MatSnackBarModule_tsickle_Closure_declarations() {
    /** @type {?} */
    MatSnackBarModule.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    MatSnackBarModule.ctorParameters;
}
//# sourceMappingURL=snack-bar-module.js.map